import { html } from 'lit';
import { ExternalLink } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-external-link')
export class PdsIconExternalLink extends PdsIcon {
  @state()
  icon = ExternalLink;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
